import React, { useEffect, useState } from 'react';
import Pagination from '../../../components/pagination';
import { getTenantRequest } from '../../../api/sportaloka-client';
import FilterModal from './FilterModal';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

function TenantTable({ onFilterLengthChanged }) {
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 10,
    sort_field: 'updated_at',
    sort_value: 'desc',
    status: [],
    site_name: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const handlePageChange = (page) => {
    setPaginationOptions({ ...paginationOptions, page });
  };

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const getStatusObject = (status) => {
    switch (status) {
      case 'NEW_REQUEST':
        return {
          color: 'yellow-4',
          textColor: 'yellow-3',
          label: 'NEW'
        };
      case 'APPROVED':
        return {
          color: 'green-1',
          textColor: 'green-2',
          label: 'ACTIVE'
        };
      case 'INACTIVE':
        return {
          color: 'red-3',
          textColor: 'red-1',
          label: 'INACTIVE',
          value: status
        };
      case 'REJECTED':
        return {
          color: 'red-3',
          textColor: 'red-1',
          label: 'REJECTED'
        };
      default:
        return {
          color: 'blue-1-05',
          textColor: 'blue-1',
          label: 'IN PROGRESS'
        };
    }
  };

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit,
        sort_field: paginationOptions.sort_field,
        sort_value: paginationOptions.sort_value,
        status: paginationOptions.status.join(','),
        site_name: paginationOptions.site_name
      }).toString();
      const response = await getTenantRequest(query);
      const responseData = response.data.data.data.map((item) => ({
        ...item,
        status: getStatusObject(item.status)
      }));
      setData(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const handleFilter = (site_name, status) => {
    let filterLength = 0;
    if (site_name) {
      filterLength = filterLength + 1;
    }
    setPaginationOptions({ ...paginationOptions, status, site_name });
    onFilterLengthChanged(filterLength + status.length);
  };

  const handleSort = (field) => {
    const isAsc = paginationOptions.sort_field === field && paginationOptions.sort_value === 'asc';
    setPaginationOptions({
      ...paginationOptions,
      sort_field: field,
      sort_value: isAsc ? 'desc' : 'asc'
    });
  };

  return (
    <div className="overflow-scroll scroll-bar-1 mb-20">
      <FilterModal onFilter={handleFilter} />
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th>Site</th>
            <th>Pemilik</th>
            <th>Status</th>
            <th className="cursor-pointer" onClick={() => handleSort('created_at')}>
              Tanggal Dibuat
              {paginationOptions.sort_field === 'created_at' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="cursor-pointer" onClick={() => handleSort('updated_at')}>
              Update Terakhir
              {paginationOptions.sort_field === 'updated_at' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="6">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data.length === 0 && !error && (
            <tr>
              <th className="text-center" colSpan="6">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="6">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={getData}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data.map((row) => (
            <tr key={row.id}>
              <td className="fw-500">{row.site_name ?? '-'}</td>
              <td>{row.users[0] ? row.users[0].fullname : '-'}</td>
              <td>
                <div
                  className={`rounded-100 py-4 d-inline px-10 text-center col-12 text-14 fw-600 bg-${row.status.color} text-${row.status.textColor}`}>
                  {row.status.label}
                </div>
              </td>
              <td>{format(new Date(row.created_at), 'dd/MM/yyyy hh:mm')}</td>
              <td>{format(new Date(row.updated_at), 'dd/MM/yyyy hh:mm')}</td>
              <td className="text-center pe-0">
                <Link
                  to={`/tenants/detail/${row.id}`}
                  className="fw-500 text-blue-1 btn btn-primary bg-blue-1 text-white btn-sm border-blue-1">
                  Detail
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        currentPage={paginationOptions.page}
        totalRows={totalRows}
        rowsPerPage={paginationOptions.limit}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

export default TenantTable;
